import { createSlice } from "@reduxjs/toolkit";
import { fetchHhExchangeNumbersLookups } from "../thunks/fetchHHAExchangeNumbersLookups";
import { phoneNumberFormatE164 } from "../../utils/phoneNumberFormatE164";

interface State {
  items: any[];
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: State = {
  items: [],
  status: "idle",
  error: null,
};

const hhaexchangeSlice = createSlice({
  name: "hhaexchange",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHhExchangeNumbersLookups.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchHhExchangeNumbersLookups.fulfilled, (state, action) => {
        state.status = "succeeded";

        const payload = Array.isArray(action.payload)
          ? action.payload
          : [action.payload];

        payload.forEach((item) => {
            if (!item?.HomePhone && !item?.Phone2 && !item?.Phone3) return;
          state.items.push({
            ...item,
            HomePhone: phoneNumberFormatE164(item.HomePhone ?? ''),
            Phone2: phoneNumberFormatE164(item.Phone2 ?? ''),
            Phone3: phoneNumberFormatE164(item.Phone3 ?? ''),
          });
        });
      })
      .addCase(fetchHhExchangeNumbersLookups.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Lookup failed";
      });
  },
});

export default hhaexchangeSlice.reducer;
